export default "__VITE_ASSET__BLTIQ7o8__"